import container from './CreateSubtypeFriendlyName.container';
import FriendlyName from './CreateSubtypeFriendlyName';
export default container(FriendlyName);
